// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"2b254c44","513":"19ec336e","703":"b4538f97"}[chunkId] + ".chunk.js";
};